var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgReleaseVoucherBatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.375 54.5H99.625C103.316 54.5 106.375 57.5586 106.375 61.25V68C106.375 68.9492 105.531 69.6875 104.688 70.0039C102.684 70.7422 101.312 72.5352 101.312 74.75C101.312 76.9648 102.684 78.8633 104.688 79.6016C105.531 79.918 106.375 80.6562 106.375 81.5V88.25C106.375 92.0469 103.316 95 99.625 95H52.375C48.5781 95 45.625 92.0469 45.625 88.25V81.5C45.625 80.6562 46.3633 79.918 47.207 79.6016C49.2109 78.8633 50.6875 76.9648 50.6875 74.75C50.6875 72.5352 49.2109 70.7422 47.207 70.0039C46.3633 69.6875 45.625 68.9492 45.625 68V61.25C45.625 57.5586 48.5781 54.5 52.375 54.5ZM59.125 66.3125C59.125 65.4688 59.8633 64.625 60.8125 64.625H91.1875C92.0312 64.625 92.875 65.4688 92.875 66.3125V83.1875C92.875 84.1367 92.0312 84.875 91.1875 84.875H60.8125C59.8633 84.875 59.125 84.1367 59.125 83.1875V66.3125ZM55.75 64.625V84.875C55.75 86.7734 57.2266 88.25 59.125 88.25H92.875C94.668 88.25 96.25 86.7734 96.25 84.875V64.625C96.25 62.832 94.668 61.25 92.875 61.25H59.125C57.2266 61.25 55.75 62.832 55.75 64.625Z",
    fill: "url(#paint0_linear_20245_426561)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20245_426561",
    x1: 76,
    y1: 48,
    x2: 76,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgReleaseVoucherBatch);
export default __webpack_public_path__ + "static/media/img_release_voucher_batch.ebce5a8a50a202ae55f8ba53b648633f.svg";
export { ForwardRef as ReactComponent };